import graphql from './graphql';

const query = /* GraphQL */ `
  query getSignedUrl($key: String) {
    getSignedUrl(key: $key) {
      signedUrl
    }
  }
`;

const S3getSignedUrl = async ({ key }) => graphql(query, { key }).then(({ getSignedUrl }) => getSignedUrl);

export default S3getSignedUrl;
